'use client';
import ConfirmAccount from '@/components/account/ConfirmAccount';
import Button from '@/components/Button';
import Modal from '@/components/layout/Modal';
import Required from '@/components/Required';
import useNavigate from '@/hooks/useNavigate';
import { BootstrapContext, ToastContext } from '@/pagesComponents/Layout';
import Errors from '@/services/errors';
import { register } from '@/services/register';
import { useContext, useEffect, useRef, useState } from 'react';

const RegisterConfirm = () => {
  const bootstrap = useContext(BootstrapContext);
  const updateToast = useContext(ToastContext);
  const navigate = useNavigate();
  const verrificationModalRef = useRef(null);
  const [modalInstance, setModalInstance] = useState(null);
  const [account, setAccount] = useState({});
  const [isOpenVerificationModal, setIsOpenVerificationModal] = useState(false);
  const [registerData, setRegisterData] = useState({
    Email: '',
    Password: '',
    ConfirmPassword: '',
    Nom: '',
    Prenom: '',
    Adresse: '',
    CodePostal: '',
    Ville: '',
    PhoneNumber: '',
  });

  // Gérer les changements dans les champs du formulaire
  const handleChange = (event) => {
    const { name, value } = event.target;
    setRegisterData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const validatePassword = (password, confirmPassword) => {
    if (password !== confirmPassword) {
      return false;
    } else {
      return password.length >= 5;
    }
  };
  const validateCodePostal = (codePostal) => {
    return codePostal.match(/^[A-Z]\d[A-Z]\d[A-Z]\d$/);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const form = event.target;
      const data = new FormData(form);
      // extract all values and names into object from formData
      const bodyToSend = Object.fromEntries(data.entries());
      const passworsIsValid = validatePassword(bodyToSend.Password, bodyToSend.ConfirmPassword);
      const codePostalIsValid = validateCodePostal(bodyToSend.CodePostal);
      if (!passworsIsValid || !codePostalIsValid) throw new Error('Vos informations ne sont pas valides');

      const body = await register(bodyToSend);
      if (body instanceof Error) {
        Errors.handleError(body, updateToast);
      } else {
        setAccount(body.data);
        openVerificationModal();
      }
    } catch (e) {
      Errors.handleError(e, updateToast);
    }
  };

  useEffect(() => {
    if (bootstrap && verrificationModalRef.current) {
      const modal = new bootstrap.Modal(verrificationModalRef.current, {
        keyboard: false,
      });
      setModalInstance(modal);
      return () => {
        modal.dispose();
      };
    }
  }, [bootstrap, verrificationModalRef]);

  const openVerificationModal = () => {
    if (modalInstance) {
      setIsOpenVerificationModal(true);
      modalInstance.show();
    }
  };

  useEffect(() => {
    if (!isOpenVerificationModal && modalInstance) {
      modalInstance.hide();
    }
  }, [isOpenVerificationModal, modalInstance]);

  useEffect(() => {
    document.getElementById('codePostal').addEventListener('input', (event) => {
      event.target.setCustomValidity('');
      if (event.target.value.length > 6) {
        const codePostalFirst3Chars = event.target.value.substring(0, 3);
        const codePostalLast3Chars = event.target.value.substring(
          event.target.value.length - 3,
          event.target.value.length
        );
        event.target.value = codePostalFirst3Chars + codePostalLast3Chars;
      }
    });
  }, []);

  return (
    <>
      <Modal
        ref={verrificationModalRef}
        id={'confirmEmailOrPhoneModal'}
        label={'confirmEmailOrPhoneModalLabel'}
        title={'Confirmer votre compte'}
        openState={[isOpenVerificationModal, setIsOpenVerificationModal]}
      >
        <ConfirmAccount
          account={account}
          resetState={[isOpenVerificationModal, setIsOpenVerificationModal]}
          sendSMSCode={() => navigate('/achats')}
        />
      </Modal>

      <div className="register-page">
        <div className="card card-1-light m-1 m-md-2 m-lg-4 title-card">
          <div className="card-title">
            <h2 className={'text-center'}>S&apos;inscrire</h2>
          </div>
        </div>
        <div className="card card-3-light m-1 m-md-2 m-lg-4">
          <div className="card-body">
            <form id="registrationForm" className={'form'} onSubmit={handleSubmit}>
              <div className="row justify-content-center my-3">
                <div className="col-12 col-md-8 col-lg-4">
                  <div className="row my-3">
                    <div className="form-group col-12 col-md-6">
                      <label className={'form-label'} htmlFor="email">
                        Adresse courriel:
                        <Required />
                      </label>
                      <input
                        id="email"
                        className={'form-control'}
                        type="email"
                        name="Email"
                        value={registerData.Email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group col-12 col-md-6">
                      <label className={'form-label'} htmlFor="phoneNumber">
                        Téléphone cellulaire:
                        <Required />
                      </label>
                      <input
                        type="number"
                        id="phoneNumber"
                        className={'form-control'}
                        name="PhoneNumber"
                        value={registerData.PhoneNumber}
                        onChange={handleChange}
                        required
                      />
                      <small className={'form-text text-primary'}>
                        Nombres seulement (nous pourrions vous envoyer des messages texte)
                      </small>
                    </div>
                  </div>
                  <div className="row my-3">
                    <div className="form-group col-12 col-md-6">
                      <label className={'form-label'} htmlFor="password">
                        Mot de passe:
                        <Required />
                      </label>
                      <input
                        id="password"
                        className={'form-control'}
                        type="password"
                        name="Password"
                        value={registerData.Password}
                        onChange={handleChange}
                        required
                      />
                      {registerData.Password.length < 5 && (
                        <small className={'form-text text-danger'}>5 characteres minimum</small>
                      )}
                    </div>
                    <div className="form-group col-12 col-md-6">
                      <label className={'form-label'} htmlFor="confirmPassword">
                        Confirmation du mot de passe:
                        <Required />
                      </label>
                      <input
                        id="confirmPassword"
                        className={'form-control'}
                        type="password"
                        name="ConfirmPassword"
                        value={registerData.ConfirmPassword}
                        onChange={handleChange}
                        required
                      />
                      {registerData.Password !== registerData.ConfirmPassword && (
                        <small className={'form-text text-danger'}>
                          les mots de pase ne correspondent pas
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="row my-3">
                    <div className="form-group col-12 col-md-6">
                      <label className={'form-label'} htmlFor="prenom">
                        Prénom:
                        <Required />
                      </label>
                      <input
                        id="prenom"
                        className={'form-control'}
                        type="text"
                        name="Prenom"
                        value={registerData.Prenom}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group col-12 col-md-6">
                      <label className={'form-label'} htmlFor="nom">
                        Nom:
                        <Required />
                      </label>
                      <input
                        id="nom"
                        className={'form-control'}
                        type="text"
                        name="Nom"
                        value={registerData.Nom}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center my-3">
                <div className="col-12 col-md-8 col-lg-6">
                  <div className="row my-3 justify-content-center">
                    <div className="form-group col-12 col-md-6 col-lg-4">
                      <label className={'form-label'} htmlFor="adresse">
                        Adresse:
                        <Required />
                      </label>
                      <input
                        id="adresse"
                        className={'form-control'}
                        type="text"
                        name="Adresse"
                        value={registerData.Adresse}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group col-12 col-md-6 col-lg-4">
                      <label className={'form-label'} htmlFor="ville">
                        Ville:
                        <Required />
                      </label>
                      <input
                        id="ville"
                        className={'form-control'}
                        type="text"
                        name="Ville"
                        value={registerData.Ville}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group col-12 col-md-6 col-lg-4">
                      <label className={'form-label'} htmlFor="codePostal">
                        Code postal:
                        <Required />
                      </label>
                      <input
                        id="codePostal"
                        className={'form-control'}
                        type="text"
                        name="CodePostal"
                        value={registerData.CodePostal}
                        onChange={handleChange}
                        required
                      />
                      {!registerData.CodePostal.match(/^[A-Z]\d[A-Z]\d[A-Z]\d$/) && (
                        <small className={'form-text text-danger'}>utilisez le format (X1X1X1)</small>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className={'d-flex justify-content-center my-3'}>
                <Button className={'btn btn-primary'} type="submit">
                  S&apos;inscrire
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterConfirm;
